export const featureAbbr = "introduction"